import React from 'react';
import { Row, Col, Space, Button } from 'antd';
import { FormattedMessage } from 'react-intl';
import imgSrc from 'assets/images/pre-datev-wizard.png';

interface Props {
  handleStartWizard: () => void;
}

const PreWizard: React.FC<Props> = ({ handleStartWizard }) => (
  <Row css="margin: 40px 0" data-testid="wizard-assistant">
    <Col xl={{ span: 12, offset: 6 }} lg={{ span: 18, offset: 2 }}>
      <Space direction="vertical" css="width: 100%" size={40}>
        <Row>
          <img
            css={`
              width: 100%;
              height: auto;
            `}
            src={imgSrc}
            alt="connect datev with shore"
          />
        </Row>
        <Row>
          <FormattedMessage defaultMessage="To connect yourd DATEV Kassenarchiv Online with your ShorePOS account, your account information must be complete. Use this assistant to check your addresses information." />
        </Row>
        <Row justify="center">
          <Button type="primary" onClick={handleStartWizard}>
            <FormattedMessage defaultMessage="Start Wizard" />
          </Button>
        </Row>
      </Space>
    </Col>
  </Row>
);

export default PreWizard;
